import React from 'react';
import SidebarStyles from "./Sidebar.module.css";
import DashboardLogo from "../../Assets/dashboard/logo.png";
import ProfilePics from "../../Assets/dashboard/profile-pics.png";
import { CgMenuGridR } from "react-icons/cg";
import { FaEdit, FaUserEdit, FaHeart, FaTimes } from "react-icons/fa";
import { IoDiamond } from "react-icons/io5";
import { HiMail } from "react-icons/hi";
import { MdOutlineConnectWithoutContact } from "react-icons/md";
import {useMediaQuery} from 'react-responsive';
import { Link } from "react-router-dom";

const Sidebar = ({ hamburgerMenu, sethamburgerMenu }) => {
    const isTablet = useMediaQuery({
        query: '(max-width: 768px)'
    })

    return (
        <>
            {
                hamburgerMenu === "active" || !isTablet ? <div className={SidebarStyles.SidebarCont}>
                    <p onClick={() => sethamburgerMenu("in-active")} className={SidebarStyles.CloseHamburger}>{isTablet && <FaTimes />}</p>

                    <div className={SidebarStyles.SidebarLogo}>
                        <img src={DashboardLogo} alt="DashboardLogo" />
                        <p>Aphrodite</p>
                    </div>

                    <div className={SidebarStyles.SidebarContProfile}>
                        <div className={SidebarStyles.SidebarContProfileInner}>
                            <div>
                                <img src={ProfilePics} alt="ProfilePics" />
                            </div>
                            <div>
                                <p className={SidebarStyles.SidebarContProfileName}>Hanifa Owuri</p>
                                <p className={SidebarStyles.SidebarContProfileRole}>Frontend Engineer</p>
                                <div className={SidebarStyles.SidebarContProfileSub}>
                                    <p className={SidebarStyles.SidebarContProfileSubInner}>FREE MODE</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={SidebarStyles.SideBarMenuCont}>
                        <div className={SidebarStyles.SideBarMenuFlexActive}>
                            <div className={SidebarStyles.SideBarMenuFlexActiveInner}>
                                <p className={SidebarStyles.SideBarMenuIconActive}><CgMenuGridR /></p>
                                <Link to="/dashboard" style={{ textDecoration: "none" }}>
                                    <p className={SidebarStyles.SideBarMenuTextActive}>
                                        Dashboard
                                    </p>
                                </Link>
                            </div>
                        </div>
                        <div className={SidebarStyles.SideBarMenuFlex}>
                            <div className={SidebarStyles.SideBarMenuFlexInner}>
                                <p className={SidebarStyles.SideBarMenuIcon}><FaEdit /></p>
                                <Link to="/dashboard/edit-profile" style={{ textDecoration: "none" }}>
                                    <p className={SidebarStyles.SideBarMenuText}>Edit Profile</p>
                                </Link>
                            </div>
                        </div>
                        <div className={SidebarStyles.SideBarMenuFlex}>
                            <div className={SidebarStyles.SideBarMenuFlexInner}>
                                <p className={SidebarStyles.SideBarMenuIcon}><IoDiamond /></p>
                                <Link to="/dashboard/premium" style={{ textDecoration: "none" }}>
                                    <p className={SidebarStyles.SideBarMenuText}>Premium</p>
                                </Link>
                            </div>
                        </div>
                        <div className={SidebarStyles.SideBarMenuFlex}>
                            <div className={SidebarStyles.SideBarMenuFlexInner}>
                                <p className={SidebarStyles.SideBarMenuIcon}><FaUserEdit /></p>
                                <Link to="/dashboard/edit-preferences" style={{ textDecoration: "none" }}>
                                    <p className={SidebarStyles.SideBarMenuText}>Edit preferences</p>
                                </Link>
                            </div>
                        </div>
                        <div className={SidebarStyles.SideBarMenuFlex}>
                            <div className={SidebarStyles.SideBarMenuFlexInner}>
                                <p className={SidebarStyles.SideBarMenuIcon}><HiMail /></p>
                                <Link to="/dashboard/messages" style={{ textDecoration: "none" }}>
                                    <p className={SidebarStyles.SideBarMenuText}>Messages</p>
                                </Link>
                            </div>
                        </div>
                        <div className={SidebarStyles.SideBarMenuFlex}>
                            <div className={SidebarStyles.SideBarMenuFlexInner}>
                                <p className={SidebarStyles.SideBarMenuIcon}><MdOutlineConnectWithoutContact /></p>
                                <Link to="/dashboard/matched" style={{ textDecoration: "none" }}>
                                    <p className={SidebarStyles.SideBarMenuText}>Matched</p>
                                </Link>
                            </div>
                        </div>
                        <div className={SidebarStyles.SideBarMenuFlex}>
                            <div className={SidebarStyles.SideBarMenuFlexInner}>
                                <p className={SidebarStyles.SideBarMenuIcon}><FaHeart /></p>
                                <Link to="/dashboard/likedyou" style={{ textDecoration: "none" }}>
                                    <p className={SidebarStyles.SideBarMenuText}>Liked You</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                    :
                    ""
            }
        </>
    )
}

export default Sidebar
